import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";

import BorderLinearProgress from "../../components/BorderLinearProgress";

import jsonUtils from "../../utils/jsonUtils";
import tratamentoUtils from "../../utils/tratamentoUtils";

import ReactStoreIndicator from "react-score-indicator";

import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

import ChartJS from "chart.js/auto";
import { Chart } from "react-chartjs-2";

import GoogleMapsComponent from "../../components/GoogleMaps"

const QuadroVisualizacaoSimples = (props) => {
    const quadro = props.quadro;
    const relatorio = props.relatorio;
    const colunas = quadro.colunas;
    const tamanho = Math.min(12, Math.ceil(12 / colunas));
    const quadroDados = quadro.quadroDados.sort(
        (a, b) => a.parametros.ordem - b.parametros.ordem
    );
    let dados = ["Razão", "CNPJ", "Logradouro", "CEP"];
    const getGrafico = (score, max = 1000) => {
        return (
            <Box maxWidth="16rem">
                <ReactStoreIndicator
                    value={score}
                    maxValue={max}
                    fadedOpacity={15}
                    width={130}
                />
            </Box>
        );
    };

    const getChart = (value, chartProps) => {
        console.log("v1");
        if (chartProps && typeof chartProps === "object") {
            return (
                <Chart
                    {...chartProps}
                    style={{
                        maxHeight: 300,
                    }}
                    data={{
                        labels: value.labels ?? [],
                        datasets: value.datasets ?? [],
                    }}
                    fallbackContent={
                        <p>Não foi possível gerar ou exibir o gráfico</p>
                    }
                />
            );
        }
    };

    const getMaps = (address) => (
        <GoogleMapsComponent address={address} />
    )

    const getDado = (dado, tratamento, maxScore = 1000, chartProps) => {
        let value = null;
        if (typeof dado == "string") {
            value = jsonUtils.getValor(dado, relatorio);
        } else {
            value = jsonUtils.getValor(dado.chave_json, relatorio);
        }

        if (
            typeof dado != "string" &&
            dados.includes(dado["nome"]) &&
            props.is_anon
        ) {
            if (value.length >= 14) {
                let x = value.substring(0, 4);
                let x1 = value
                    .substring(4, value.length - 4)
                    .replace(/([a-zA-Z\d])/g, "X");
                let x2 = value.substring(value.length - 4, value.length);
                value = x + x1 + x2;
            } else {
                let x = value.substring(0, 1);
                let x1 = value
                    .substring(1, value.length - 2)
                    .replace(/([a-zA-Z\d])/g, "X");
                let x2 = value.substring(value.length - 2, value.length);
                value = x + x1 + x2;
            }
        }
        value =
            value != undefined
                ? tratamentoUtils.executarTratamento(tratamento, value)
                : "-";

        if (value != "-" && tratamento && tratamento.includes("graficoScore")) {
            maxScore = maxScore ? maxScore : 1000;
            return getGrafico(value, maxScore);
        }

        if (value != "-" && tratamento && tratamento.includes("chart")) {
            return getChart(value, chartProps);
        }

        if (value != "-" && tratamento && tratamento.includes("maps")) {
            return getMaps(value);
        }

        if (typeof value === "object") {
            return "";
        }

        return value;
    };

    return (
        <Box className="zoomPrinter">
            <Typography variant={props.subQuadro ? "h7" : "h5"}>
                {quadro.titulo}
            </Typography>
            <Grid
                container
                spacing={4}
                style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
            >
                {quadroDados.map((qd, index) => (
                    <Grid key={index} item xs={6} md={tamanho}>
                        <Grid
                            container
                            spacing={props.subQuadro ? 1 : 2}
                            direction="column"
                        >
                            <Grid item>
                                <Box
                                    color="#999"
                                    fontSize={props.subQuadro ? 14 : 16}
                                >
                                    {qd.parametros.nome}
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box
                                    color="#17325C"
                                    fontSize={props.subQuadro ? 14 : 16}
                                >
                                    {getDado(
                                        qd.dado,
                                        qd.tratamento,
                                        qd.parametros.max_score,
                                        qd.chartProps
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default QuadroVisualizacaoSimples;
